const Dec6_JoinUs_FEB_Block_Box_H_Text = ['Fresh Graduates','Apprenticeship'];

export {Dec6_JoinUs_FEB_Block_Box_H_Text};